import styled from "styled-components";

const CocktailIngredient = styled.div`
  display: flex;
  padding: 10px 10px;
  align-items: center;
  justify-content: right;
`;

export default CocktailIngredient;
